import React from 'react';
import '../../styles/onboardingFlow/onboarding/onboardingMain.scss';
import OnboardingBusinessType from './OnboardingBusinessType';
import OnboardingAddClient from './OnboardingAddClient';
import OnboardingIntegration from './OnboardingIntegration';
import OnboardingInstallPlugin from './OnboardingInstallPlugin';
import AskTara from './AskTara';

interface OnboardingMainProps {
  currentStep: number;
  onStepChange?: (stepNumber: number) => void;
}

const OnboardingMain: React.FC<OnboardingMainProps> = ({ currentStep }) => {
  return (
    <div className='onboardingMain'>
      {currentStep === 1 && <OnboardingBusinessType />}
      {currentStep === 2 && <OnboardingAddClient />}
      {currentStep === 3 && <OnboardingInstallPlugin />}
      {currentStep === 4 && <OnboardingIntegration />}
      {currentStep === 5 && <AskTara />}
    </div>
  );
};

export default OnboardingMain;
